import type { FC, ReactNode } from 'react'

import { Box, Grid } from '@sequencehq/core-components'

type PhasePropertyEditorLayoutProps = {
  propertyInput?: ReactNode
  removeButton?: ReactNode
  operatorInput: ReactNode
  subRow?: ReactNode
}

const getGridTemplateAreas = (hasRemoveButton: boolean, hasSubRow: boolean) => {
  if (hasRemoveButton && hasSubRow) {
    return '"primary remove" "subRow subRow"'
  }
  if (hasRemoveButton) return '"primary remove"'
  if (hasSubRow) return '"primary" "subRow"'
  return '"primary"'
}

export const PhasePropertyEditorLayout: FC<PhasePropertyEditorLayoutProps> = ({
  propertyInput,
  removeButton,
  operatorInput,
  subRow
}) => (
  <Grid
    gridTemplateColumns={
      removeButton ? 'minmax(0, 1fr) auto' : 'minmax(0, 1fr)'
    }
    gridTemplateAreas={getGridTemplateAreas(
      Boolean(removeButton),
      Boolean(subRow)
    )}
    gap="8px"
  >
    <Grid
      gridArea="primary"
      gridTemplateColumns={propertyInput ? '1fr 1fr' : '1fr'}
      gap="8px"
      minWidth={0}
    >
      {propertyInput && <Box minWidth={0}>{propertyInput}</Box>}
      <Box minWidth={0}>{operatorInput}</Box>
    </Grid>
    {removeButton && <Box gridArea="remove">{removeButton}</Box>}
    {subRow && (
      <Box gridArea="subRow" minWidth={0}>
        {subRow}
      </Box>
    )}
  </Grid>
)
